module.exports = __webpack_public_path__ + "img/HUB-Loading.ed74ec54.gif";